<template>
  <ContextMenu
    :visible="visible"
    :positionX="position.x"
    :positionY="position.y"
    @closeContextMenu="$emit('close')"
  >
    <div>
      <b-list-group>
        <b-list-group-item
          href="#"
          @click.prevent="toggleSubTabs"
          class="contextMenu__toggle"
        >
          {{ hasSubTabs ? 'Remove Sub Page' : 'Add Sub Page' }}
          <b-badge v-if="hasSubTabs" variant="danger" pill>
            <icon name="remove" />
          </b-badge>
        </b-list-group-item>
        <b-list-group-item
          v-if="!hasSubTabs"
          href="#"
          @click.prevent="setTabOnLoad"
          class="contextMenu__toggle"
        >
          Selected by default
          <b-badge v-if="tabOnLoad === currentTab" variant="primary" pill>
            <icon name="check" />
          </b-badge>
        </b-list-group-item>
        <b-list-group-item
          v-if="$count(tabs) > 1"
          href="#"
          @click.prevent="togglePrivateTab"
          class="contextMenu__toggle"
        >
          Private
          <b-badge
            v-if="privateTabs.includes(currentTab)"
            variant="primary"
            pill
          >
            <icon name="check" />
          </b-badge>
        </b-list-group-item>
        <b-list-group-item
          v-if="hasSubTabs"
          href="#"
          @click.prevent="toggleExpandedByDefault"
          class="contextMenu__toggle"
        >
          Expanded by default
          <b-badge v-if="isSelectedByDefault" variant="primary" pill>
            <icon name="check" />
          </b-badge>
        </b-list-group-item>
        <b-list-group-item href="#" @click.prevent="renameTab">
          Rename
        </b-list-group-item>
        <b-list-group-item href="#" @click.prevent="showTabIconModal">
          Icon
        </b-list-group-item>
        <b-list-group-item
          v-if="$count(tabs) > 1"
          href="#"
          @click.prevent="deleteTab"
        >
          Delete
        </b-list-group-item>
      </b-list-group>
    </div>
    <TabRenameModal ref="tabRenameModal" :tabs="tabs" />
  </ContextMenu>
</template>

<script>
import { mapState } from 'vuex'
import { find } from 'lodash'
// components
import ContextMenu from '@/components/ContextMenu'
import TabRenameModal from '../modals/TabRename'
// servics
import db from '@/services/db'
// helpers
import eventBus from '@/helpers/event-bus'

export default {
  props: [
    'visible',
    'position',
    'tabs',
    'tabOnLoad',
    'privateTabs',
    'hasSubTabs',
  ],
  components: {
    ContextMenu,
    TabRenameModal,
  },
  computed: {
    ...mapState(['currentTab']),
    isSelectedByDefault() {
      return (
        (find(this.tabs, { key: this.currentTab }) || {}).expandedByDefault ===
        true
      )
    },
  },
  methods: {
    deleteTab() {
      let confirmDel = confirm('Are you sure?')

      if (!confirmDel) return
      this.$emit('close')

      db.tabs.delete(
        this.currentTab,
        err => {
          this.$emit('delete')
        },
        this.hasSubTabs
      )
    },
    setTabOnLoad() {
      db.tabs.setTabOnLoad(
        this.currentTab === this.tabOnLoad ? null : this.currentTab
      )
    },
    togglePrivateTab() {
      let privateTabs = []

      if (this.privateTabs.includes(this.currentTab)) {
        privateTabs = this.privateTabs.filter(tab => tab !== this.currentTab)
      } else {
        privateTabs = this.privateTabs.slice()
        privateTabs.push(this.currentTab)
      }

      db.tabs.setPrivateTab(privateTabs)
    },
    toggleExpandedByDefault() {
      const tab = find(this.tabs, { key: this.currentTab })

      db.tabs.toggleExpandedByDefault(
        this.currentTab,
        (tab || {}).expandedByDefault || false
      )
    },
    renameTab() {
      this.$refs.tabRenameModal.open()
    },
    toggleSubTabs() {
      if (this.hasSubTabs) this.removeSubTabs()
      else this.addSubTabs()
    },
    addSubTabs() {
      eventBus.$emit('showAddSubTabModal')
    },
    removeSubTabs() {
      db.tabs.removeSubTabs(this.currentTab, () => {
        const query = Object.assign({}, this.$route.query)
        delete query.subtab
        this.$router.replace({ query })
      })
    },
    showTabIconModal() {
      eventBus.$emit('showTabIconModal')
    },
  },
}
</script>
